import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";
const Footer = () => {
  return (
    <>
      <section className="footer-section">
        <div className="container">
          <div className="logo-div">
            <Link to="/"> <img src={process.env.PUBLIC_URL + "/Assets/Images/logo/Absar_logo.png"} alt="logo" className="footer-logo" /></Link>
          </div>
          <div className="row  first-row">
            <div className="col-10 first-col">
              <Link to={"/"} className="footer-link">Home</Link>
              <Link to={"/about-us"} className="footer-link">About US</Link>
              <Link to={"/contact-us"} className="footer-link">Contact Us</Link>
              <Link to={"/privacy-policy"} className="footer-link">Privacy Policy</Link>
              <Link to={"/terms-condition"} className="footer-link">Terms & Conditions</Link>
            </div>
          </div>
          <div className="row  second-row">
            <div className="second-col">
              <p className="footer-address" > <a href="http://google.com/maps/@26.789660199769713,79.02323071193652,15z?entry=ttu&g_ep=EgoyMDI1MDIwMi4wIKXMDSoASAFQAw%3D%3D" target="_blank" className="icon-target"><i class="fa fa-map-marker icon" aria-hidden="true"></i></a>104 ashok nagar Ashok nagar etawah 206001</p>
            </div>
          </div>
          <div className="row  third-row">
            <div className="col-10 third-col">
              <a className="fa-text"><i className="fa fa-phone fa-icon" />+91 7668201518</a>
              <a className="fa-text"><i className="fa fa-envelope fa-icon" />absarmoney@gmail.com</a>
            </div>
          </div>
          <div className="row  forth-row">
            <div className=" forth-col">
              <Link to="https://www.facebook.com/login/" target="_blank" className="icon-target"><i
                class="fa fa-facebook-square icon" aria-hidden="true"></i></Link>
              <Link to="https://www.linkedin.com/home" target="_blank" className="icon-target"><i
                class="fa fa-linkedin-square icon" aria-hidden="true"></i></Link>
              <Link to="https://x.com/i/flow/login" target="_blank" className="icon-target"><i class="fa fa-twitter-square icon"
                aria-hidden="true"></i></Link>
              <Link to="https://www.youtube.com/" target="_blank" className="icon-target"><i class="fa fa-youtube-play icon" aria-hidden="true"></i></Link>

            </div>
          </div>
          <div className="row fifth-row">
            <div className="col-8 fifth-col">
              <p className="footer-bottom">@2025 Absarmoney solutions pvt. ltd. All Right Reserved.</p>
            </div>
          </div>

        </div>

      </section>
    </>
  );
};

export default Footer;
